import { useSyncExternalStore } from "react";

// Tracks a CSS media query, so JS-driven behavior can switch at exactly the
// same breakpoint as the Tailwind classes it sits next to (e.g. `lg:hidden`).
export function useMediaQuery(query: string) {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
